import type { IconSvgProps } from "@modules/ui/components/huButtonIcon"

export const BoxLeadMergeIcon: React.FC<IconSvgProps> = (props) => (
  <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_24230_24497)">
      <path
        d="M5.75008 9.83366C8.00524 9.83366 9.83341 8.00549 9.83341 5.75033C9.83341 3.49516 8.00524 1.66699 5.75008 1.66699C3.49492 1.66699 1.66675 3.49516 1.66675 5.75033C1.66675 8.00549 3.49492 9.83366 5.75008 9.83366Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.25008 13.3337C11.5052 13.3337 13.3334 11.5055 13.3334 9.25033C13.3334 6.99516 11.5052 5.16699 9.25008 5.16699C6.99492 5.16699 5.16675 6.99516 5.16675 9.25033C5.16675 11.5055 6.99492 13.3337 9.25008 13.3337Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_24230_24497">
        <rect width="14" height="14" fill="white" transform="translate(0.5 0.5)" />
      </clipPath>
    </defs>
  </svg>
)
